export enum TransactionType {
  POS = 'POS',
  ECOMMERCE = 'ECOMMERCE',
  ATM = 'ATM',
}
